import { useMutation, useQueryClient } from "@tanstack/vue-query";
import ProjectsApi from "@/common/http/ProjectsApi";
import { onSettled } from "./onSettled";

export const mutationKey = ["update-recommendation-feedback"];

export const useUpdateRecommendationFeedback = (props = {}) => {
  const queryClient = useQueryClient();

  const { mutate, ...mutationRest } = useMutation({
    mutationFn: ProjectsApi.updateRecommendationFeedback,
    mutationKey,
    onSettled: onSettled({ queryClient }),
    ...props,
  });

  return {
    updateRecommendationFeedback: mutate,
    ...mutationRest,
  };
}
